// PLUGINS IMPORTS //
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import ExpositionItem from './ExpositionItem/ExpositionItem'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { iPadProResolution } from 'Content/Shared/Styles/Theme'

// REDUX
import { getExpositionsThunkCreator } from 'Redux/Reducers/ExpositionsReducer'
import { getExpositionsSelector } from 'Redux/Selectors/ExpositionsSelector'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const Exposition: React.FC<PropsType> = () => {
  const expositions = useSelector(getExpositionsSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getExpositionsThunkCreator())
  }, [])

  return (
    <Wrapper>
      {expositions
        .filter((item) => item.title)
        .map((item, index) => {
          const isRight = !(index % 2 === 0)
          return (
            <ExpositionItem key={item.ID} exposition={item} isRight={isRight} />
          )
        })}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN_HORIZONTAL = '0px'
const Wrapper = styled.div`
  margin-top: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-right: ${MARGIN_HORIZONTAL};
  margin-left: ${MARGIN_HORIZONTAL};

  @media (max-width: ${iPadProResolution}px) {
    margin-top: -30px;
  }
`

export default React.memo(Exposition, memoComparison)
